import { FC } from 'react'
import styled from 'styled-components'
import MenuItemIcon from './MenuItemIcon'
import MenuItemFull from './MenuItemFull'
import { useMenuItems, useMenuItemDisabled } from '../../_methods'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  padding: 4px 8px;
  overflow-y: auto;
  overflow-x: initial;
`

interface NavigationProps {
  collapsed: boolean
}

const Navigation: FC<NavigationProps> = ({ collapsed }) => {
  const items = useMenuItems()
  const isItemDisabled = useMenuItemDisabled()

  const MenuItem = collapsed ? MenuItemIcon : MenuItemFull

  return (
    <Wrapper>
      {items.map(item => (
        <MenuItem key={item.id} item={item} disabled={isItemDisabled(item)} />
      ))}
    </Wrapper>
  )
}

export default Navigation
